import React from 'react';
import { useReframe } from 'nike-re-framejs';
import Article from '@/article/views/Article';
import imports from '@/routing/imports';
import Loadable from '@/common/lazy/Loadable';
import { CONTACT_US, CONTACT_US_INFO, OFFICES } from '@/routing/routes';
import { ContactForm } from 'nike-ui/src/components/contact/ContactForm';
import { accountActionAllowed$ } from '@/account/subs';

const Offices = Loadable({ loader: imports.offices });

/**
 *  Root path component; params: []
 */
const Contact = ({ route }) => {
    const { subscribe } = useReframe();
    const showContractId = subscribe(accountActionAllowed$('SHOW_CONTRACT_ID'));
    return (
        <>
            {route === OFFICES ? <Offices /> : null}
            {route === CONTACT_US ? (
                <div className="layout-rw px-20 pt-30">
                    <ContactForm showContractId={showContractId} />
                </div>
            ) : null}
            {route === CONTACT_US_INFO ? <Article articleCode="contact-text" /> : null}
        </>
    );
};

export default Contact;
